module.exports = __webpack_public_path__ + "img/wexperts_screenshot.ff4928b3.jpg";